import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import App from './App.vue'
import './assets/sass/main.scss'
import routes from './routes'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history', 
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  }
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title && r.meta.description);

  if (nearestWithTitle) {
    const title = nearestWithTitle.meta.title,
          description = nearestWithTitle.meta.description;
    document.title = title;

    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    const ogTitle = document.createElement('meta'),
          ogDescription = document.createElement('meta'),
          descriptionTag = document.createElement('meta');

    ogTitle.setAttribute('og:title', title);
    ogTitle.setAttribute('data-vue-router-controlled', '');
    document.head.appendChild(ogTitle);

    ogDescription.setAttribute('og:description', description);
    ogDescription.setAttribute('data-vue-router-controlled', '');
    document.head.appendChild(ogDescription);

    descriptionTag.setAttribute('description', description);
    descriptionTag.setAttribute('data-vue-router-controlled', '');
    document.head.appendChild(descriptionTag);
  }

  if (from.query.leadid && !to.query.leadid) {
    if (to.path === from.path) {
      return
    }
    next({path: to.path, query: {leadid: from.query.leadid}})
  }
  next()
});

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_KEY,
    libraries: 'places'
  },
  installComponents: false
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
